import { Inject, Injectable, DOCUMENT } from '@angular/core';
import { ThemeSetting } from '@masar/common/models';

@Injectable()
export class ThemeService {
    public constructor(@Inject(DOCUMENT) private document: Document) {}

    private static readonly schemeClasses = [
        'scheme-soft',
        'scheme-clear',
        'scheme-bold',
    ];

    public apply(theme: ThemeSetting): void {
        const levels = [50, 100, 200, 300, 400, 500, 600, 700, 800, 900];

        levels.forEach((level, index) => {
            this.document.documentElement.style.setProperty(
                `--primary-${level}`,
                theme.primary[index]
            );
            this.document.documentElement.style.setProperty(
                `--secondary-${level}`,
                theme.secondary[index]
            );
        });

        this.document.documentElement.classList.toggle(
            'colored-sidebar',
            theme.isColoredSidebar ?? false
        );

        // Apply scheme class
        const scheme = theme.scheme || 'soft';
        ThemeService.schemeClasses.forEach(cls => {
            this.document.documentElement.classList.remove(cls);
        });
        if (scheme !== 'soft') {
            this.document.documentElement.classList.add(`scheme-${scheme}`);
        }
    }
}
